import React from 'react';
import { Form, InputGroup, Button, Alert, Badge, ListGroup } from 'react-bootstrap';
import { FaMoneyBillWave, FaShareSquare, FaSpinner, FaEdit, FaTrash } from 'react-icons/fa';
import CustomRichTextEditor from '../CustomRichTextEditor';

export default function ExtraTab({
    noteForm,
    onInputChange,
    isObgynDoctor,
    isAssistant,
    editingNote,
    isNoteDateToday,
    isNoteDateInFuture,
    referralWrapperRef,
    referralTo,
    setReferralTo,
    referralContent,
    setReferralContent,
    uniqueReferralTos,
    isLoadingUniqueReferralTos,
    isReferralDropdownOpen,
    setIsReferralDropdownOpen,
    savingReferral,
    editingReferralId,
    handleSaveReferral,
    handleCancelEditReferral,
    loadingReferrals,
    referrals,
    handleEditReferral,
    handleDeleteReferral,
}) {
    return (
        <>
            <div className="mb-4 p-3 border rounded-3" style={{ background: '#f9fafb' }}>
                <div className="d-flex align-items-center mb-2">
                    <div className="me-2 text-success"><FaMoneyBillWave /></div>
                    <div>
                        <div className="fw-semibold">Visit Fee</div>
                        <small className="text-muted">Leave empty to use the default consultation fee.</small>
                    </div>
                </div>
                <InputGroup>
                    <InputGroup.Text className="fw-semibold">IQD</InputGroup.Text>
                    <Form.Control
                        type="number"
                        name="fee"
                        value={noteForm.fee ?? ''}
                        onChange={onInputChange}
                        placeholder="e.g., 15000"
                        min={0}
                        step="1"
                    />
                </InputGroup>
            </div>

            {isObgynDoctor && (
                <Form.Group className="mb-4">
                    <Form.Label>Last Menstrual Period (LMP)</Form.Label>
                    <Form.Control
                        type="date"
                        name="lmp"
                        value={noteForm.lmp || ''}
                        onChange={onInputChange}
                    />
                </Form.Group>
            )}

            <div className="mb-2 p-3 border rounded-3" style={{ background: '#f9fafb' }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center">
                        <span className="me-2 text-primary"><FaShareSquare /></span>
                        <h5 className="mb-0">Medical Referrals</h5>
                    </div>
                </div>

                {(!isAssistant && ((!editingNote && isNoteDateToday()) || (editingNote && !isNoteDateInFuture()))) ? (
                    <>
                        <Form.Group className="mb-2">
                            <Form.Label className="mb-1">To</Form.Label>
                            <div className="position-relative" ref={referralWrapperRef}>
                                <Form.Control
                                    type="text"
                                    value={referralTo}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setReferralTo(val);
                                        const hasFilter = (val || '').trim().length > 0;
                                        setIsReferralDropdownOpen(hasFilter);
                                    }}
                                    onFocus={() => {
                                        setIsReferralDropdownOpen(true);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Escape') setIsReferralDropdownOpen(false);
                                    }}
                                    placeholder="مثل: مستشفى/طبيب/قسم"
                                    maxLength={255}
                                    className="text-end"
                                    dir="rtl"
                                    autoComplete="off"
                                />
                                {isLoadingUniqueReferralTos && (
                                    <div className="text-muted small mt-1">Loading suggestions...</div>
                                )}
                                {(() => {
                                    const filter = (referralTo || '').trim().toLowerCase();
                                    const base = Array.isArray(uniqueReferralTos) ? uniqueReferralTos : [];
                                    const filtered = (filter ? base.filter(s => s && s.toLowerCase().includes(filter)) : base).slice(0, 10);
                                    return (isReferralDropdownOpen && filtered.length > 0) ? (
                                        <div className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 2000, maxHeight: '180px', overflowY: 'auto' }}>
                                            {filtered.map((s, i) => (
                                                <button
                                                    key={i}
                                                    type="button"
                                                    className="list-group-item list-group-item-action py-1 text-end"
                                                    onClick={() => { setReferralTo(s); setIsReferralDropdownOpen(false); }}
                                                    title={s}
                                                >
                                                    {s}
                                                </button>
                                            ))}
                                        </div>
                                    ) : null;
                                })()}
                            </div>
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <Form.Label className="mb-1">Content</Form.Label>
                            <CustomRichTextEditor
                                value={referralContent}
                                onChange={(html) => setReferralContent(html)}
                                placeholder="Enter referral details..."
                                style={{ minHeight: '120px' }}
                                alignmentOnly
                            />
                        </Form.Group>
                        <div className="mb-3 d-flex align-items-center gap-2">
                            <Button
                                variant="success"
                                type="button"
                                onClick={handleSaveReferral}
                                disabled={savingReferral || !referralTo.trim() || !referralContent.trim()}
                            >
                                {savingReferral ? (
                                    <><FaSpinner className="fa-spin me-2" />Saving...</>
                                ) : (
                                    editingReferralId ? 'Update Referral' : 'Add Referral'
                                )}
                            </Button>
                            {editingReferralId && (
                                <Button
                                    variant="outline-secondary"
                                    type="button"
                                    onClick={handleCancelEditReferral}
                                    disabled={savingReferral}
                                >
                                    Cancel Edit
                                </Button>
                            )}
                        </div>
                    </>
                ) : (
                    <Alert variant="info" className="py-2">
                        {isAssistant ? 'Assistants cannot add referrals.' : 'Referrals are available on the appointment day or later.'}
                    </Alert>
                )}

                <div className="mt-2">
                    {loadingReferrals ? (
                        <div className="text-muted small"><FaSpinner className="fa-spin me-1" /> Loading referrals...</div>
                    ) : referrals.length === 0 ? (
                        <div className="text-muted small">No referrals yet.</div>
                    ) : (
                        <ListGroup variant="flush" className="bg-white border rounded-3">
                            {referrals.map((ref) => (
                                <ListGroup.Item key={ref.id} className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <Badge bg="primary" className="me-2">Referral</Badge>
                                        <div>
                                            <div className="fw-semibold">To: {ref.to}</div>
                                            {ref.created_at && (
                                                <small className="text-muted">Created: {new Date(ref.created_at).toLocaleString()}</small>
                                            )}
                                        </div>
                                    </div>
                                    {!isAssistant && !isNoteDateInFuture() && (
                                        <div className="d-flex align-items-center gap-2">
                                            <Button
                                                variant="link"
                                                className="text-primary p-0 me-2"
                                                title="Edit referral"
                                                onClick={() => handleEditReferral(ref)}
                                            >
                                                <FaEdit />
                                            </Button>
                                            <Button
                                                variant="link"
                                                className="text-danger p-0"
                                                title="Delete referral"
                                                onClick={() => handleDeleteReferral(ref.id)}
                                            >
                                                <FaTrash />
                                            </Button>
                                        </div>
                                    )}
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </div>
            </div>
        </>
    );
}
